import React from "react";
import Home from "../components/home/Home"; 

const HomeScreen = () => {
  return (
    <div>
      {/* <h1></h1> */}
      <Home />
    </div>
  );
};

export default HomeScreen;
